import { render, staticRenderFns } from "./base-radio.vue?vue&type=template&id=c28be2b6&"
import script from "./base-radio.vue?vue&type=script&lang=js&"
export * from "./base-radio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports